import { connect } from "react-redux";
import {
  addCommOnlyOperationalPartner,
  removeCommOnlyOperationalPartner,
  updateCommOnlyOperationalPartner,
} from "../actions/creators";
import Dropdown from "../../../../shared/v2/Dropdown/Dropdown";
import TextButton from "../../../../shared/v2/TextButton/TextButton";
import FormElement from "./FormElement";
import AvatarControl from "./AvatarControl";
import AvatarOption from "./AvatarOption";
import DisplayPerson from "./DisplayPerson";

const CommOnlyOperator = ({
  formData,
  partners,
  addCommOnlyOperationalPartner,
  updateCommOnlyOperationalPartner,
  removeCommOnlyOperationalPartner,
}) => {
  const selectedCommPartners = formData?.commOnlyOperationalPartners?.map((p) => p.value?.value);
  const availableCommPartners = partners.filter((p) => selectedCommPartners.indexOf(p.value) <= -1);
  return (
    <div className="tw-flex tw-flex-col tw-gap-[8px]">

      {formData?.commOnlyOperationalPartners?.map((partner, idx) => (
        <FormElement key={idx} label={`Comm-Only Operator ${idx === 0 ? '' : idx + 1}`}>
          <DisplayPerson
            value={partner.value}
            options={availableCommPartners}
            onDelete={() => {
              removeCommOnlyOperationalPartner({ index: idx });
              if(idx === 0 && selectedCommPartners.length === 1) addCommOnlyOperationalPartner();
            }}
            onChange={(val) => updateCommOnlyOperationalPartner({ index: idx, value: val })}
          />
        </FormElement>
      ))}
      <TextButton onClick={addCommOnlyOperationalPartner} size="medium" className="tw-self-start">
        + Comm-Only Operator
      </TextButton>
    </div>
  );
};

export default connect(({ superUsersBranding: { formData, partners } }) => ({ formData, partners }), {
  addCommOnlyOperationalPartner,
  removeCommOnlyOperationalPartner,
  updateCommOnlyOperationalPartner,
})(CommOnlyOperator);
